import { ComponentsFormTranslation } from '@/assets/locales/components/form/components.form.translation.en.ts';

export const componentsFormTranslation: ComponentsFormTranslation = {
  select: {
    noOptionsMessage: 'Brak dostępnych opcji',
    selected: 'Wybrano: {{value}}',
  },
};
